class ModalDialog {

  constructor() {
    this.debug = false;
    this.dialog = null;
    // this.structure_email_Selector = null;
    // this.services_Options_Selector = null;
  }

  init() {

    var url = new URL(window.location.href);
    this.debug = url.searchParams.get("debug");
    if(this.debug) console.log('ModalDialog DEBUG enabled', this.debug);

    let _self = this;

    // Formulaire être rappelé
    this.dialogs = $('dialog.t-dialog');

    if(this.dialogs.length) {

      if(this.debug) console.log('this.dialogs', this.dialogs);

      this.dialogs.each(function(i,dialog){

        let dialogOrigin = $('#'+$(dialog).attr('data-dialog-origin'));

        dialogOrigin.append('<a class="dialog-toggle"></a>');

        dialogOrigin.find('.dialog-toggle').on('click', function(e){
        // $(window).on('click', '#connexion-compare-dummy', function(e){

          if(_self.debug) console.log('ModalDialog click', e);

          e.preventDefault();
          e.stopPropagation();

          dialog.showModal();


          $(dialog).on('click.closeModalDialog', function(e){
            if(this.debug) console.log('compare click', e.target, e.currentTarget);
            if($(e.target).is('dialog') && !$(e.target).is('form')) {
              dialog.close();
            }
            // $('#connexion-compare-dialog').get(0).showModal();
          });
          $(dialog).one('close.closeModalDialog', function(e){
            if(this.debug) console.log('compare close', e);
            $(dialog).off('click.closeModalDialog');
          });

          return false;

        });

      });

    }


  }


}

export { ModalDialog };
